export default function CancelPage() {
  return (
    <div className="p-8 max-w-xl mx-auto">
      <h1 className="text-2xl font-semibold mb-2">Checkout Canceled</h1>
      <p className="text-muted-foreground">No changes have been made. You can retry the checkout anytime from the pricing dialog.</p>
    </div>
  );
}

